/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicAmazonCatalogue.internal

import features.publicAmazonCatalogue.models.PublicRewardsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class PublicAmazonCatalogueRequest : NetworkRequest() {

    suspend fun getPublicAmazonCatalogue(
        overrideHeaders: Map<String, String>? = null,
        pageNumber: Int,
        perPage: Int,
        keywords: String?,
        filters: String?
    ): IOResult<PublicRewardsModel> {
        return safeNetworkCall {
            get(
                endpoint = PublicAmazonCatalogueEndpoint.replaceInPath(
                    PathParameter("pageNumber", pageNumber),
                    PathParameter("perPage", perPage),
                    PathParameter("keywords", keywords),
                    PathParameter("filters", filters),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
